module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2AqQz"))).then(() => parcelRequire('f4eak'));